import $ from 'jquery';
import { logEngagement, logEngagementWithDetails } from "../../modules/global/log-engagement";

const SMART_FILTER_PARAM = 'sf';
const DELIMITER = "-";

$(function() {
  $('#reset-smart-filters').on('click', function() {
    $('.js-smart-filter').prop('disabled', false).prop('checked', false);

    logEngagement(window.location.href, 'smart_filters', 'start over');
    submitFilters(true);

    // Hand off modal + search box reset to smart-filters.js. Must stay after
    // submitFilters, which reads form state before the search box is cleared.
    $(document).trigger('smartFilters:reset');
  });

  $('#submit-smart-filters').on('click', function() {
    $('.js-modal-close').trigger('mousedown');
    const ignoreHistory = $(this).data('ignoreHistory');
    $(this).data('ignoreHistory', false);

    logEngagement(window.location.href, 'smart_filters', 'apply filters');
    submitFilters(!ignoreHistory);
  });

  $('.js-smart-filters').on('click', () => {
    if (getSmartFilters()) {
      updateValidFilters();
    }
  });

  $('#smart-filters-form input').on('change', function() {
    updateValidFilters();
    const $this = $(this);
    logEngagementWithDetails(window.location.href,
      'smart_filter',
      $this.is(':checked') ? 'select' : 'deselect',
      $this.attr('id'));
  });

  function updateValidFilters() {
    const data = getSmartFilters();
    // data can contain hidden fields, only check if user has selected anything
    if ($('.js-smart-filter:checked').length) {
      const $container = $('#main-content');
      const ajaxUrl = appendQuery(removeURLParameter($container.data('baseUrl'), SMART_FILTER_PARAM), data)
        .replace(/.*\?/, `${window.rcProps.smartFiltersCheckHref}?`);
      $.get(ajaxUrl).done((result) => {
        const validFilters = Object.keys(result).reduce((set, filterType) => {
          let filterNames = result[filterType];

          for (let filterName of filterNames) {
            set.add(`sf_${filterType}_${filterName}`);
          }

          return set;
        }, new Set());

        const selectedCategories = $('.js-smart-filter:checked').toArray().reduce((set, el) => {
          set.add($(el).attr('name'));

          return set;
        }, new Set());

        $('.js-smart-filter').each(function() {
          const $el = $(this);
          $el.prop('disabled', !(
            $el.is(':checked') || validFilters.has($el.attr('id')) || selectedCategories.has($el.attr('name')))
          );
        });
      });
    } else {
      $('.js-smart-filter').each(function() {
        $(this).prop('disabled', false);
      });
    }
  }

  function submitFilters(updateHistory) {
    const data = getSmartFilters();

    const $container = $('#main-content');
    const filtersToClear = {
      pageNum: true,
    };
    filtersToClear[SMART_FILTER_PARAM] = true;
    filtersToClear['sortBy'] = true;
    const windowUrl = appendQuery(clearQueryParameters(window.location.href, filtersToClear), data);
    const baseUrl = $container.data('baseUrl');
    const ajaxUrl = baseUrl.indexOf('?') > 0
      ? windowUrl.replace(/.*\?/, `${$container.data('baseUrl')}&`)
      : windowUrl.replace(/.*\?/, `${$container.data('baseUrl')}?`)

    if (updateHistory) {
      window.history.pushState({}, "", windowUrl);
    } else {
      window.history.replaceState({}, "", windowUrl);
    }
    new ContentUpdate($container, ajaxUrl, false, null, () => {
      const $filterCount =  $('.js-filter-count');
      let count = (Number.parseInt($filterCount) || 0) + $('.js-smart-filter:checked').length;
      $filterCount.text(count > 0 ? '(' + count + ')' : '');
      getMultiselectLeftNav();
    }).go();

    if (insertPageTrack && typeof insertPageTrackWithInfo === 'function') {
      insertPageTrackWithInfo(windowUrl, true);
    }
  }

  function getSmartFilters() {
    return $('#smart-filters-form input')
      .toArray()
      .filter((filter) => filter.hidden || filter.checked)
      .map((filter) => `${SMART_FILTER_PARAM}=${filter.dataset.filterType}${DELIMITER}${filter.value}`)
      .join('&');
  }

  window.onpopstate = function () {
    $('#selected-filters').empty();
    const selectedFilters = new Set();
    const searchParams = new URLSearchParams(location.search);
    searchParams.forEach((value, key) => {
      if (key === SMART_FILTER_PARAM) {
        selectedFilters.add(value);
      }
    });

    const $filters = $('#smart-filters-form input[type="checkbox"]');
    $filters.prop('disabled', false).prop('checked', false).each(function() {
      const $this = $(this);

      if (selectedFilters.has(`${$this.prop('name')}${DELIMITER}${$this.prop('value')}`)) {
        $this.prop('checked', true);
      }
    });

    // go through the button so the active filter pills rebuild too
    $('#submit-smart-filters').data('ignoreHistory', true).trigger('click');
    updateValidFilters();
  };
});



// WEBPACK FOOTER //
// ./src/scripts/entry-points/search/index.js